import { adminMenuItems } from '@/mocks/adminData';

interface SidebarProps {
  activeMenu: string;
  onMenuChange: (key: string) => void;
  collapsed: boolean;
  onToggleCollapse: () => void;
}

export default function Sidebar({ activeMenu, onMenuChange, collapsed, onToggleCollapse }: SidebarProps) {
  return (
    <aside className={`${collapsed ? 'w-16' : 'w-56'} bg-secondary-950 text-white flex flex-col transition-all duration-300 shrink-0 min-h-screen`}>
      <div className="flex items-center h-14 px-4 border-b border-secondary-800">
        {!collapsed && (
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-primary-500 rounded flex items-center justify-center shrink-0">
              <span className="text-white font-bold text-xs">스</span>
            </div>
            <span className="text-sm font-bold text-primary-500 whitespace-nowrap">관리자</span>
          </div>
        )}
        <button
          onClick={onToggleCollapse}
          className={`${collapsed ? 'mx-auto' : 'ml-auto'} w-6 h-6 flex items-center justify-center text-foreground-400 hover:text-white transition-colors`}
        >
          <i className={`ri-${collapsed ? 'menu-unfold' : 'menu-fold'}-line text-sm`} />
        </button>
      </div>

      <nav className="flex-1 py-3 overflow-y-auto">
        {adminMenuItems.map((item) => (
          <button
            key={item.key}
            onClick={() => onMenuChange(item.key)}
            className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm transition-colors whitespace-nowrap ${
              activeMenu === item.key
                ? 'bg-primary-500 text-white'
                : 'text-foreground-300 hover:bg-secondary-800 hover:text-white'
            }`}
          >
            <i className={`${item.icon} text-base`} />
            {!collapsed && <span>{item.label}</span>}
          </button>
        ))}
      </nav>

      <div className="px-4 py-3 border-t border-secondary-800">
        {!collapsed && <p className="text-xs text-foreground-500">스카연 CMS v1.0</p>}
      </div>
    </aside>
  );
}